import React from "react";
import { Button, ButtonGroup, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faTrash,
  faInfoCircle,
  faKey,
} from "@fortawesome/free-solid-svg-icons";

const ApplicationActionCell = (props) => (
  <Row style={{ display: "block" }}>
    <div className="floatRight">
      <ButtonGroup size="sm">
        <Button
          className="btn-black"
          onClick={(event) => {
            event.stopPropagation();
            props.onNewToken();
          }}
        >
          <FontAwesomeIcon icon={faKey} size="1x" />
        </Button>
        <Button
          className="btn-green"
          onClick={(event) => {
            event.stopPropagation();
            props.onEdit();
          }}
        >
          <FontAwesomeIcon icon={faPen} size="1x" />
        </Button>
        <Button
          className="btn-red"
          onClick={(event) => {
            event.stopPropagation();
            props.onDelete();
          }}
        >
          <FontAwesomeIcon icon={faTrash} size="1x" />
        </Button>
        <Button
          className="btn-black"
          onClick={(event) => {
            event.stopPropagation();
            props.onShowInfo();
          }}
        >
          <FontAwesomeIcon icon={faInfoCircle} size="1x" />
        </Button>
      </ButtonGroup>
    </div>
  </Row>
);

export default ApplicationActionCell;
